import "index.css";
import {HomePageView} from "home-page-view";

let homePageView = new HomePageView();

document.getElementById("main").appendChild(homePageView.root);
